import { createAction, createErrorAction } from './actionCreator';
import { CardUser, ActionsType } from '@card/types';

export enum UsersActionType {
  Fetch = 'cardUser/fetch',
  FetchSuccess = 'cardUser/fetch_success',
  FetchError = 'cardUser/fetch_failed'
}

export const UsersActions = {
  fetch: () => createAction(UsersActionType.Fetch),
  fetchSuccess: (user: CardUser) => createAction(UsersActionType.FetchSuccess, user),
  fetchError: (error: Error) => createErrorAction(UsersActionType.FetchError, error)
};

export type UsersAction = ActionsType<typeof UsersActions>;
